import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: "20px" }}>
      <h1 style={{textAlign:'center'}}>iYuga Privacy Policy</h1>
      <h4 style={{textAlign:'center'}}>Updated 1/9/24</h4>
      <p>
        iYuga.com Inc ("iYuga", "Company", "we", "our", or "us") values the
        privacy of visitors and users of its Site, App, and Services ("User" or
        "you"), and is dedicated to safeguarding the personal information shared
        with us. It is important for you to be informed about how we may collect
        and use information during your visit and/or use of our Site, App, and
        Services. This policy applies to personal information collected from:
        (i) individual Users who access and use the Site, App, and Services for
        their personal benefit, and (ii) Users who access and use the Site, App,
        and Services on behalf of an organization. Terms that are capitalized
        but not defined in this Privacy Policy are understood as defined in our
        Terms of Use at{" "}
        <a href="https://www.iYuga.com ">https://www.iYuga.com</a>(“Terms”),
        which this Privacy Policy is a part of by reference.
      </p>

      {/* Introduction and Acceptance of Terms */}
      <h2>1. Introduction and Acceptance of Terms</h2>
      <p>
        By accessing, connecting to, or using the Site, and/or by installing the
        App on your mobile device, and engaging with the App, you, on your own
        behalf and, where applicable, on behalf of your organization, consent to
        the terms outlined in this Privacy Policy (“Privacy Policy”), including
        the collection, processing, transfer, and use of your personal
        information as described. If you do not agree with any of the terms in
        this policy, you should not install, access, or use the App, and should
        promptly uninstall the App from your mobile device. To clarify, by
        agreeing to this Privacy Policy, you are giving your consent to the
        collection, processing, transfer, and use of your personal information.
        You also acknowledge and understand that prov
      </p>

      {/* Information We Collect */}
      <h2>2. Information We Collect</h2>
      {`We gather two kinds of data from our Users:
a. Non-identifiable and anonymous information ("Non-personal Information"), where we
don't know the identity of the User. This includes general data that doesn't reveal an
individual User's identity, collected during their interaction with the Site and/or App or
upon installing the App. It encompasses technical, behavioral, and aggregated
information such as User activity on the Site and/or App, operating system type, device
type and version, User's browsing actions, product interactions, browser type, key iYuga
features, device specifications (including screen resolution), time spent on various parts
of the Site and/or App, User demographics, traffic patterns, etc.
b. Information that can personally identify an individual, such as name, phone number,
country of residence, company name, and email address, or other contact details
(“Personal Information”). This could include sensitive or private information.
IP Address: When using the Site and/or App, Users automatically provide their IP
address (or Mac Address, as applicable) for enhancing user experience and for
geo-location and security purposes.
Account: Personal Information is collected when Users register to create an Account on
the Site and/or App, including name, company name, phone number, and email
address.
Communications with iYuga: We collect Personal Information that you provide during
any communication with iYuga, including customer service interactions. This may
include marketing preferences and communication data.
Payment: For Subscription Fees, payments are made through a third-party Marketplace
requiring payment and Personal Information (e.g., credit card details). We do not access
or store this information on our servers, only securely holding token information
provided by Marketplaces.
Mailing List: When you join our mailing list, we collect contact details such as your
name, email address, and other contact information.
Important Note: We enable certain Users to receive aggregated and anonymized data
about their followers' activities through the Site and/or App ("User Analytics"). This
includes analytics and insights on their followers' usage of the App, Site, and shared
User Content. If you use the Services, you warrant and represent that you will provide
necessary notices and obtain required consents under applicable law for us to monitor
follower usage and collect, process, and provide you their User Analytics.
Cross-referencing Data: We may cross-reference Personal Information with other
Personal Information and any Non-personal Information linked or associated with
Personal Information will be considered Personal Information as long as the connection
exists.
Consent for Collection: We do not collect Personal Information without your consent,
obtained through your acceptance of the Terms of Use and Privacy Policy.`}

      {/* How We Collect Information */}
      <h2>3. How We Collect Information</h2>
      {`We employ several primary methods for information collection:
a. Collection through Interaction: We gather information during your use of the App, as
well as when you access and use the Site. Essentially, whenever you interact with our
Services, we take note and may collect, gather, and store data related to your usage
activities.
b. Voluntary Provision of Information: We collect information that you voluntarily provide
to us. This includes, for instance, the Personal Information you submit when registering
and creating an Account.
This information may be collected either directly by us or through the assistance of
authorized third-party service providers, as further outlined in our practices.`}

      <h2>4. Purpose and Use of Collected Information</h2>
      {`
Our Privacy Policy outlines the purposes for which we collect Non-personal and
Personal Information:
Purpose of Collecting Non-personal Information:
● To utilize it for statistical analysis, research, customization, and improvement of
our Services. This includes processing User Content in an anonymized,
non-identifiable manner to identify general trends, analytics, and preferences
unlinked to specific individuals.
● To enhance the User experience while utilizing our Services.
● Purpose of Collecting Personal Information:
● To provide Users with access to our App, Site, and Services.
● To offer Analytics Services to Users, particularly team leaders.
● To update Users about the Company's developments, new offerings, and news
related to our Services.
● To keep Users informed about updates to our products and Services.
● To contact Users as requested.
● To send push notifications to the User’s device, subject to their consent. Users
can opt out of push notifications via their service settings.
● To verify User identity for signing into the Services and prevent fraudulent use.
● To reach out to Users for technical assistance and support related to the Site or
App.
● To conduct internal operations like troubleshooting, data analysis, testing, and
research for Service improvement. We typically analyze aggregate data for these
purposes but may examine specific cases to address particular issues.
● To ascertain the general geolocation (i.e., country) of the User’s computer or
device for understanding the geographical distribution of our Users and to
safeguard our Site and App.
● To facilitate payments through third-party Online Payment Processors, noting that
we do not collect and store credit card or other financial information.`}

      <h2>5. Sharing and Disclosure of Information</h2>
      {`
iYuga maintains the confidentiality of Personal Information except in the following
instances:
● To comply with laws, regulations, legal processes, or governmental requests.
● To enforce our Terms, including investigating potential breaches.
● To address fraud, security, or technical issues.
● To handle User support requests for the Site or App.
● To address claims that any Content infringes third-party rights.
● To address claims of unauthorized posting or transmission of a third party's
contact information (e.g., name, email address) without consent or as
harassment.
● To protect the rights, property, or safety of iYuga, its Users, or the public.
● In case of a change in control of the Company, such as mergers, acquisitions, or
asset sales (the new entity may be in a different jurisdiction with different data
protection laws).
● To manage Personal Information via third-party service providers, possibly
located in countries with different data protection laws.
● To store or process Personal Information through affiliated companies, possibly
located in countries with different data protection laws.
● For legitimate business purposes, including enhancing User experience.
● With your explicit consent prior to disclosure.
It should be noted that iYuga has the unrestricted right to use and share Non-personal
Information at its discretion for any purpose, including with third parties.`}

      <h2>6. User Rights and Access to Information</h2>
      {`We recognize that in certain situations, you may have the right to access, modify, or
request the deletion of your Personal Information that we collect and process. To
exercise these rights, please reach out to us at support@iYuga.net. We will assist you in
fulfilling these rights in accordance with applicable laws. Unless specified otherwise in
this document or directed by you, we may keep your Personal Information for as long as
necessary for the purposes for which it was collected, in compliance with relevant
privacy laws.
Please be aware that de-identified or aggregate information derived from your use of
our Services may be stored on our servers indefinitely.
Additionally, local laws in your jurisdiction may grant you specific privacy rights,
including the right to access, correct, erase, limit processing of, transfer, or object to the
processing of your Personal Information. If you wish to exercise these rights and are
unable to do so through the Website or Application, please contact us at
support@iYuganet for assistance.`}

      <h2>7. Security Measures</h2>

      {`We implement industry-standard technologies and internal processes to safeguard the
security and integrity of our Site, App, and the information of our users, aiming to
prevent any unauthorized access or use. However, it's important to recognize that
transmitting information over the Internet or storing it electronically carries inherent
risks. While we strive to protect your personal information, we cannot assure absolute
security against unauthorized access or use.
PLEASE BE AWARE THAT OUR COMPANY IS NOT LIABLE FOR ANY
UNAUTHORIZED ACCESS, HACKING, OR OTHER SECURITY BREACHES, NOR
FOR THE THEFT, DELETION, CORRUPTION, DESTRUCTION, DAMAGE, OR LOSS
OF ANY DATA.`}

      <h2>8. Social Media Integrations</h2>
      {`Our Platform incorporates features for social media integration ("Social Features") that
allow for connectivity with select third-party social media networks or platforms ("Social
Networks"). These Social Networks are developed and managed by third parties
independent of iYuga. When you choose to interact with these Social Networks, the
terms of use and privacy policies of those respective third-party networks will apply. We
recommend reviewing these documents to understand their practices in handling
information and to learn how you can manage your privacy and sharing settings.
Should you disagree with these terms, you have the option to refrain from engaging with
these Social Networks, which may result in limited access to some features on our
Platform. In instances where you interact with a Social Network, be aware that we may
exchange information about you and your contacts (and vice versa) to enhance the
service's social experience. This information may include, among other things, your
name and social media profile picture.
By utilizing the Social Features, you acknowledge that the relevant Social Networks or
Platforms may gather your Personal Information (such as your IP address) and
Non-personal Information, and may use cookies or similar tracking technologies for the
functionality of the Social Features. The use of these features may allow for the sharing
of information with your friends or the public, in accordance with your privacy settings on
these third-party platforms. Please be aware that when you share content via Social
Networks, it can become public and may be further disseminated by others.`}

      <h2>9. Third Party Integrations and Service Providers</h2>
      {`Our services may utilize third-party software or services for various purposes, including
but not limited to collecting, hosting, storing, and processing the information outlined in
this policy. These third-party entities might be situated in countries with data protection
laws that differ from those in your jurisdiction. We only partner with third-party
organizations that adhere to legal obligations similar to ours and that maintain a clear
privacy policy regarding their handling of both non-personal and personal data. It's
important to note, however, that we do not have control over these third-party service
providers. We encourage you to review their terms of use and privacy policies to better
understand their approaches to privacy.`}

      <h2>10. International Data Transfer</h2>
      {`We reserve the right to share the information we collect, including personal details, with
our affiliated entities or external third-party service providers as described in this
document. This may involve transferring your data across international borders, from
your country or jurisdiction to different countries or jurisdictions globally. Be aware that
these transfers may lead to your information being processed in a country whose data
protection laws may differ from those in your own jurisdiction. By using our services, you
agree to this transfer of your information.`}

      <h2>11. Links to External Sites</h2>
      {`The Site and/or App may include links to external services, applications, or websites.
Our Company does not oversee or control the privacy policies or content of these
third-party resources. These external resources often have their own legal documents,
such as terms of service and privacy policies, which govern their usage. We strongly
recommend reviewing these documents thoroughly to understand how these external
sites manage your data, including what information they gather.`}

      <h2>12. Cookies and Tracking Technologies</h2>

      {`When you use our Site and/or App, we and/or our third-party service providers may
employ widely-used technologies like cookies, web beacons, pixels, clear gifs, and
other similar mechanisms, storing certain information locally on your device ("Local
Storage"). This allows us to recognize your device among other users, enhance
performance, provide personalized service tailored to individual interests and device or
browser type, track Site and/or App usage, gather approximate geographic location
data, prevent fraud and abuse, estimate audience size and usage patterns, conduct
analytics, and deliver targeted ads.
The information is stored locally on your device. iYuga and/or our authorized third-party
service providers can access this data. We may use both session cookies (which expire
when you close your browser) and persistent cookies (remaining until you delete them).
This Local Storage may hold non-personal data (like page views within the Site and/or
App) and a persistent identifier, collected as described herein.
Most devices and browsers allow you to delete cookies from your hard drive, block
cookies, or receive alerts before a cookie is stored. Blocking or deleting cookies may
limit your experience with the Site and/or App. If you don't block cookies, the Site and/or
App will use them when you visit. To remove existing cookies, you can manually delete
them anytime. However, this won't stop future cookies unless you adjust your browser
settings as described above. For specific instructions on blocking cookies, refer to your
browser’s 'help', 'tool', or 'edit' section.
You can opt-out of performance cookies tracking your browsing activity on the Site
and/or App. We use Google Analytics, which employs persistent cookies for tracking.
Google offers a browser add-on to opt-out of Google Analytics across all websites,
available here: https://tools.google.com/dlpage/gaoptout. For information on opting out
of Google's cookie use, visit Google's Ads Settings.`}

      <h2>13. Policy Regarding Minors</h2>
      {`The Site and App are designed for users who are at least sixteen (16) years old.
Consequently, we do not intentionally gather personal information from individuals
under the age of sixteen (16), nor do we wish to. We may ask for age verification at any
point to ensure that no one under sixteen (16) is using our Services. If it comes to our
attention that we have inadvertently collected personal information from minors under
sixteen (16), we will promptly remove such information from our records. Should you
believe that we have inadvertently obtained personal information from individuals under
sixteen (16), please contact us as outlined in the “Contact Us” section, and we will take
immediate action to rectify this.`}

      <h2>14. Direct Marketing and User Consent</h2>
      {`By accepting this policy, you consent to our use of your contact information to send you
information about products, services, updates, and new features that might interest you,
as well as other materials, to the email address you provided during registration. You
have the option to withdraw your consent at any time by following the unsubscribe
instructions included in our emails, or by reaching out to us as outlined in the "Contact
Us" section below.`}

      <h2>15. Changes to the Privacy Policy</h2>
      {`This Privacy Policy dictates the terms for using the Site and/or App and handling any
information collected through them. The Company may modify this policy at any time,
so we encourage you to periodically review this page. In the event of a significant
change, we will post a clear announcement on the Site and/or App or send an email to
the address you have provided, if any. Major changes will become effective seven (7)
days after they are posted on our Site and/or App, or communicated via email,
whichever occurs first. All other updates to this Privacy Policy will be effective from the
"Last Revised" date specified, and your continued use of the Site and/or App beyond
this date signifies your acceptance of and agreement to the updated terms. Should
there be any amendments to comply with legal requirements, these may come into
effect immediately, or as mandated by law, without prior notice. Any changes to this
Privacy Policy will not be retroactively applied.`}

      <h2>16. Contact Us</h2>
      <p>
        Should you have any inquiries or feedback regarding this Privacy Policy,
        please feel free to email us at support@iyuga.net and we will respond
        within a reasonable timeframe.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
